<template>
  <div>
    <div>
      <label>
        <gmap-autocomplete @place_changed="setPlace" style="width:500px" />
      </label>

      <br/>
    </div>

    <br>

    <gmap-map
      :center="{ lat: parseFloat(editable.lat || 0), lng: parseFloat(editable.lng || 0) }"
      :zoom="parseInt(editable.mapZoom, 10) || 0"
      @zoom_changed="zoom => editable.mapZoom = zoom"
      style="width:500px;  height: 200px;">

      <gmap-marker
        :position="{ lat: parseFloat(editable.lat || 0), lng: parseFloat(editable.lng || 0) }" />

    </gmap-map>

  </div>
</template>

<script>
export default {
  name: 'GoogleMap',
  props: {
    lat: [String, Number],
    lng: [String, Number],
    mapZoom: [String, Number],
  },
  watch: {
    'editable.lat': {
      deep: true,
      handler(lat) {
        this.$emit('onChangeLat', lat);
      },
    },
    'editable.lng': {
      deep: true,
      handler(lng) {
        this.$emit('onChangeLng', lng);
      },
    },
    'editable.mapZoom': {
      deep: true,
      handler(zoom) {
        this.$emit('onChangeMapZoom', zoom);
      },
    },
    lat(value) {
      this.editable.lat = value;
    },
    lng(value) {
      this.editable.lng = value;
    },
    mapZoom(value) {
      this.editable.mapZoom = value;
    },
  },
  methods: {
    setPlace(place) {
      this.editable.lat = place.geometry.location.lat().toFixed(5);
      this.editable.lng = place.geometry.location.lng().toFixed(5);
    },
  },
  data() {
    return {
      editable: {
        lat: this.lat,
        lng: this.lng,
        mapZoom: this.mapZoom,
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/winery/detail-row/GoogleMap.vue